import ModalDeleteFilled from '../../../../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalDeleteBuyDeliveryNoteDraftProps extends ModalEditComponentProps { }

const ModalDeleteBuyDeliveryNoteDraft: React.FC<ModalDeleteBuyDeliveryNoteDraftProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/order/buy/buyDeliveryNote/deleteBuyDeliveryNoteDraft',
        data: {
            id: allRowData?.header?.id,
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteDraftBuyDeliveryNote', '¿Seguro que quieres eliminar este borrador de albarán?'),
            subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo')
        }} />
    )
}

export default ModalDeleteBuyDeliveryNoteDraft